import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"240px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "回答済みのフォーム")
], -1)
const _hoisted_7 = { class: "mb20" }
const _hoisted_8 = {
  key: 0,
  class: "fr"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs12 fw600" }, "グループメモ:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  id: "otherAnsweredFormContent"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "回答した調整ページがありませんでした。", -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "mt20 mb10" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "fw600 fl mt1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_RoomLightOverViewContent = _resolveComponent("RoomLightOverViewContent")!
  const _component_AnsweredFormTable = _resolveComponent("AnsweredFormTable")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "AnsweredFormModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.member)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                width: "30",
                height: "30",
                class: "fr pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
              }, null, 8, _hoisted_3)
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.isOpenPrivateMemoContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", {
                        style: {"width":"120px","padding":"4px 10px"},
                        class: "circle_button fw600 centered fs11 blueAround",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPrivateMemo && _ctx.openPrivateMemo(...args)))
                      }, " グループメモを追加 ")
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_IconHelp, {
                        width: 18,
                        class: "fl mr10",
                        tooltipText: `お相手には見えないメモです。グループ内でのやりとりやメモにご利用いただけます。`,
                        style: {"margin-top":"-3px","margin-right":"5px"}
                      }),
                      _hoisted_11,
                      _createVNode(_component_TextareaTag, {
                        placeholder: "お相手に見えないメモを保存",
                        style: {"height":"100px","min-width":"90%"},
                        class: "fs14 roundForm fl",
                        value: _ctx.privateMemo,
                        onInputValue: _ctx.inputPrivateMemo
                      }, null, 8, ["value", "onInputValue"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(`fl ${
                                _ctx.privateMemo == _ctx.member.private_memo ? `greyBg` : `skyblueBg`
                            } rad5 fs11 pointer hoverGreyBg`),
                        style: {"padding":"13px","height":"100px"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSavePrivateMemo && _ctx.clickSavePrivateMemo(...args)))
                      }, " 保存 ", 2)
                    ])),
                _hoisted_12
              ]),
              _hoisted_13,
              _createElementVNode("div", {
                class: _normalizeClass(`roomsCategoryTab categoryAll pointer centered fl ${
                        _ctx.selectedTabName == 'current' ? 'selected fw600' : ''
                    }`),
                style: {"width":"50%"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCategoryTab('current')))
              }, " 今回 ", 2),
              (_ctx.member)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'other' ? 'selected fw600' : ''
                    }`),
                    style: {"width":"50%"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectCategoryTab('other')))
                  }, " 他の調整ページの回答を表示 ", 2))
                : _createCommentVNode("", true),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_ctx.selectedTabName == `other`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_ctx.otherResults)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", {
                              class: "pointer fs13 skyblue fw600 fl",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.backSelectRoom && _ctx.backSelectRoom(...args)))
                            }, "<回答一覧に戻る"),
                            _hoisted_18,
                            _createVNode(_component_RoomLightOverViewContent, {
                              room: _ctx.otherRoom,
                              appo: _ctx.otherRoom.current_appointment
                            }, null, 8, ["room", "appo"]),
                            _hoisted_19,
                            _createVNode(_component_AnsweredFormTable, {
                              results: _ctx.otherResults,
                              room: _ctx.otherRoom,
                              attendees: _ctx.otherAttendees,
                              canEdit: true,
                              onUpdateAnsweredResults: _ctx.updateAnsweredResults
                            }, null, 8, ["results", "room", "attendees", "onUpdateAnsweredResults"])
                          ]))
                        : (!_ctx.otherRooms)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_RoomsLoader)
                            ]))
                          : (_ctx.otherRooms.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                  width: "40",
                                  height: "40"
                                }, null, 8, _hoisted_23)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (_ctx.member)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherRooms, (_room, roomindex) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "pointer",
                                          onClick: ($event: any) => (_ctx.clickRoomCell(_room)),
                                          key: roomindex
                                        }, [
                                          _createVNode(_component_RoomLightOverViewContent, {
                                            room: _room,
                                            appo: _room.current_appointment
                                          }, null, 8, ["room", "appo"])
                                        ], 8, _hoisted_26))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_AnsweredFormTable, {
                        results: _ctx.results,
                        room: _ctx.room,
                        attendees: _ctx.attendees,
                        canEdit: true,
                        onUpdateAnsweredResults: _ctx.updateAnsweredResults
                      }, null, 8, ["results", "room", "attendees", "onUpdateAnsweredResults"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignFormAnswerResultsDic, (aformAnswerResults, aformPubId) => {
                        return (_openBlock(), _createElementBlock("div", { key: aformPubId }, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/form_assign.png`),
                              width: "18",
                              height: "17",
                              class: "restricted_calendar fl"
                            }, null, 8, _hoisted_29),
                            _createElementVNode("p", _hoisted_30, " " + _toDisplayString(aformPubId) + "の振り分けフォームでの回答", 1),
                            _hoisted_31
                          ]),
                          _createVNode(_component_AnsweredFormTable, {
                            results: aformAnswerResults,
                            room: _ctx.room,
                            canEdit: false,
                            onUpdateAnsweredResults: _ctx.updateAnsweredResults
                          }, null, 8, ["results", "room", "onUpdateAnsweredResults"]),
                          _hoisted_32
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}